import { TextInput } from '@mantine/core';
import { IconSearch, IconX } from '@tabler/icons-react';
import type { Table } from '@tanstack/react-table';
import { useState, useEffect } from 'react';
import { useDebouncedCallback } from '@mantine/hooks';

type DataTableSearchBoxProps<TData> = {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  table: Table<TData>;
  setShowFilter?: (showFilter: boolean) => void;
  classNames?: { input?: string };
  placeholder?: string;
};

export default function DataTableSearchBox<TData>({
  placeholder = 'Search',
  size = 'xs',

  table,
  setShowFilter,
  classNames,
}: DataTableSearchBoxProps<TData>) {
  const [searchValue, setSearchValue] = useState(table.getState().globalFilter || '');

  const debouncedSetFilter = useDebouncedCallback((value: string) => table.setGlobalFilter(value), 800);

  const { globalFilter } = table.getState();

  // Sync search box with table's global filter state
  useEffect(() => {
    if (globalFilter !== '') {
      setShowFilter?.(true);
    }
    setSearchValue(globalFilter || '');
  }, [globalFilter, setShowFilter]);

  return (
    <TextInput
      size={size}
      leftSection={<IconSearch size={14} />}
      classNames={{ input: classNames?.input }}
      rightSection={
        !!searchValue && (
          <IconX
            className="cursor-pointer"
            size={14}
            onClick={() => {
              setSearchValue('');
              table.setGlobalFilter('');
            }}
          />
        )
      }
      placeholder={placeholder}
      onChange={(e) => {
        setSearchValue(e.target.value);
        debouncedSetFilter(e.target.value);
      }}
      value={searchValue}
    />
  );
}
